import { graphql } from '@api/mesa'
import type {
  CancelScheduledTransferMutation,
  CancelScheduledTransferMutationVariables,
} from '@api/mesa/graphql'
import { useMutation } from '@apollo/client'
import * as CardActivity from '@/src/experiences/card-activity'
import { CardPaymentsGql } from '@/src/experiences/card-payments/gql'

export function useCancelScheduledTransfer(
  options?: Parameters<
    typeof useMutation<CancelScheduledTransferMutation, CancelScheduledTransferMutationVariables>
  >[1],
) {
  return useMutation(
    graphql(`
      mutation CancelScheduledTransfer($scheduledTransferId: String!) {
        cancelScheduledTransfer(scheduledTransferId: $scheduledTransferId) {
          __typename
          ... on MesaUserError {
            message
          }
        }
      }
    `),
    {
      awaitRefetchQueries: true,
      ...options,
      refetchQueries: options?.refetchQueries || [
        CardPaymentsGql.Queries.GET_RECURRING_SCHEDULED_PAYMENTS,
        CardActivity.Components.Highnote.ScheduledTransfers.GET_INCOMING_SCHEDULED_TRANSFERS,
      ],
    },
  )
}
